import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJqueryComponent } from './simple-icons-jquery.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJqueryComponent ],
    exports:      [ SimpleIconsJqueryComponent ],
    bootstrap:    []
})
export class SimpleIconsJqueryModule {}
